export default function getDeviceFingerprintDetails(): io.flow.v0.unions.DeviceFingerprintDetails {
  return {
    type: 'browser',
    time_zone_offset: new Date().getTimezoneOffset(),
    screen_width: window.screen.width,
    screen_height: window.screen.height,
    color_depth: window.screen.colorDepth,
    java_enabled: window.navigator.javaEnabled(),
  };
}
